import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PageHero from '../evenementielle/components/PageHero';
import ServicesShowcase from './components/ServicesShowcase';
import Creation3DGallery from './components/Creation3DGallery';
import Creation3DCta from './components/Creation3DCta';

const Creation3DIntro = () => (
  <section className="bg-brand-beige py-16 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <p className="font-serif text-xl lg:text-2xl text-brand-anthracite leading-relaxed italic">
        "Donnez vie à vos idées grâce à la création 3D."
      </p>
      <div className="h-px w-24 bg-brand-gold mx-auto mt-6" />
    </div>
  </section>
);

const Creation3DPage = () => (
  <>
    <title>Création 3D Abidjan | Figurines & Objets Personnalisés | Ev & Co Design</title>
    <meta name="description" content="Création 3D sur mesure à Abidjan : figurines personnalisées, objets décoratifs, goodies d'entreprise. Studio Ev & Co Design, Côte d'Ivoire." />
    <meta name="keywords" content="création 3D Abidjan, impression 3D Côte d'Ivoire, figurines personnalisées Abidjan" />
    <link rel="canonical" href="https://evcodesign-ci.com/creation-3d" />
    <meta property="og:title" content="Création 3D Abidjan | Ev & Co Design" />
    <meta property="og:description" content="Donnez vie à vos idées avec la création 3D : figurines, objets, goodies sur mesure à Abidjan." />
    <main className="font-sans bg-brand-beige min-h-screen">
      <Navbar />
      <PageHero
        title="Création 3D"
        subtitle="Figurines personnalisées, objets sur mesure, goodies et éléments décoratifs — la technologie 3D au service de votre créativité."
        image="https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/a3f06b9a1ceade7539c8d01a452d9569.jpeg"
        imageAlt="Création 3D Abidjan"
        breadcrumb="Création 3D"
      />
      <Creation3DIntro />
      <ServicesShowcase />
      <Creation3DGallery />
      <Creation3DCta />
      <Footer />
    </main>
  </>
);

export default Creation3DPage;
